import { isLocalSeoUser } from 'src/common/config/FunctionHelper';
import { SEOSpaceLocal } from 'src/common/config/TextMessage';
const isLocalSeo = isLocalSeoUser() || null;
export const MapRankTexts = {
  helmetTitle: 'SEOSpace | Map Rank Tracker',
  breadCrumbTitle: 'Local Ranking Tracker',
  headTutorial: 'Local Ranking Tracker Tutorial',
  upgradeTitle: 'Local Ranking Tracker',
  upgradeDesc: 'Outrank Competitors on Google Maps',
  upgradeSubDesc:
    'See exactly where you rank in your area and how you compare to local competitors. Spot weak zones, track progress, and spy on competitor rankings to improve your local visibility.',
  mapAnalyzeTitle: 'Local Ranking Tracker',
  previousSearch: 'Previous Searches',
  profileNameLabel: 'Enter Google Business Profile name',
  selectGridArea: 'Select grid area',
  selectGridSize: 'Area you want to rank in',
  enterKeyword: 'Words people search to find you',
  selectCategory: 'Type of business you run',
  visitCustomers: 'Do you go to their location?',
  search: 'Search',
  recommendedKeywords: 'Recommended keywords: ',
  recommendedKeywordsOptions:
    'wedding photographer, best food in NYC, photo studio',
  createLocalRankingMap: 'Create Local Ranking Map',
  createLocalRankingMapDesc:
    "This grid outlines the specific locations around your business where we'll pinpoint your ranking for the chosen keyword. Define your search parameters above to generate your visibility map.",
  breadCrumbTitleResults: 'Results',
  enteredKeyword: 'Entered Keyword: ',
  overviewFor: 'Overview for',
  averageMapRank: 'Average Map Rank',
  averageMapRankTooltip:
    'The average place a business appears in Google Maps results across the selected area. A lower number means better rankings.',
  visibility: 'Visibility',
  visibilityTooltip:
    'The percentage of times a business shows up in the top 3 results on Google Maps within the chosen area. These are the results most people click on.',
  localRankingMap: 'Local Ranking Map',
  exportAsPNG: 'Export PDF Report',
  localRankingMapDesc:
    'A grid-based map showing how your business ranks in search results compared to local competitors, based on exact locations around your business and common keywords.',
  recommendActions: 'Recommend Actions',
  overallTopRankingCompetitors: 'Overall Top Ranking Competitors',
  overallTopRankingCompetitorsDesc:
    'Top-10 performing search results competitors, based on Local Search Grid for ',
  noDataFound: 'No Data Found',
  resultModalTitle: 'Results for: ',
  resultModalBtnText: 'Done',
  tabRecommendationsText: 'Recommendations',
  tabRelevantCitationsText: 'Relevant Citations',
  tabVulnerableCompetitorsText: 'Vulnerable Competitors',
  keywordsToSearch: 'Keywords to Search: ',
  searchKeywords: 'Search Keywords',
  startNewText: 'Start New Search',
  showResultsFor: 'Show Results For',
  mapRankingTool: 'Local Ranking Tracker',
  mapRankingSubTitle: 'Outrank Competitors on Google Maps',
  mapRankingSubDesc:
    'Use the heatmap to track rankings across your service area and uncover gaps. Get tailored recommendations to strengthen visibility where you need it most.',
  breadCrumbTitlePrevious: 'Previous Searches',
  previousSearches: 'Previous Searches',
  mapAnalyzeTooltipTitle: `Check where your website ranks in different places. Helpful for ${
    isLocalSeo ? SEOSpaceLocal : 'local SEO'
  } and businesses with customers in specific areas.`,
  profileAddressLabel: 'Enter Google Business Profile Address',
  checkStatus: 'Check Status',
  stillInProgress:
    "We’re working on your ranking. You can check the status after some time by clicking the 'Check Status' button.",
  keywordTooltip:
    ' Enter keywords your customers might type into Google to find your business. We use them to accurately generate local map rank reports. ',
  watchTutorial: 'Watch tutorial',
  watchTutorialLink: 'https://www.youtube.com/watch?v=-CFM5v_p6_g'
};

export const OverallTopRankingCompetitorsToolTipRowTexts = [
  '#',
  'The exact name of the business as it appears on Google. We use this to find and track it in search results.',
  'The average number of stars the business has on Google, out of 5.',
  'Shows how often the business appears in the top 3 spots on Google Maps within the selected area. These top 3 spots are the first results most people see when they search.',
  'This means Average Ranking Position. It tells you the business’s usual position in local Google results. An ARP of 2 means it often shows in second place nearby.'
];

export const ResultModalToolTipRowTexts = [
  '#',
  'The exact name of the business as it appears on Google. We use this to find and track it in search results.',
  'The number of reviews the business has on Google. More positive reviews can help it appear higher in search results.',
  'The average number of stars the business has on Google, out of 5.'
];
